import { observable } from 'mobx'

import { CommonContainer } from 'src/models/Common'
import { i18nTranslate } from 'src/utils'
import { customerContainer } from 'src/models'
import { toastState } from 'src/views/components'

/**
 * TeamContainer class that extends CommonContainer.
 * This is likely the container component for rendering Team data.
 */
class ParticipantsContainer extends CommonContainer {
  constructor(props) {
    super(props)
  }
  @observable participantsResponse = {}
  @observable activePage = 1
  PAGESIZE = 5

  /**
   * Fetches a list of participants
   */
  getParticipantsList = async () => {
    const accountId = await this.getAccountId()
    const queryParams = {
      size: this.PAGESIZE,
      page: this.activePage,
      fullProfile: true,
      sort: 'id,DESC',
      filter: 'userId NOTIN ' + customerContainer?.userId,
    }
    const loadParams = {
      endPointName: 'accountProfile',
      pathParams: `${accountId}/buyers`,
      queryParams,
    }
    const response = await this.fetchResponse(loadParams)
    this.participantsResponse = response
    return response
  }
  updateActivePageOnDelete = async () => {
    const currentPageParticipantsLength =
      this.participantsResponse.accountBuyer?.length || 0
    if (currentPageParticipantsLength == 1 && this.activePage > 1) {
      this.activePage = this.activePage - 1
    }
  }
}

const participantsContainer = new ParticipantsContainer()

export default ParticipantsContainer
export { participantsContainer, ParticipantsContainer }
